<template>
    <DataPanel :reqData="reqData" :title="title" serviceName="queryTiketDetail">
        <div slot-scope="slotProps">
            <div class="opt-wrap">
                <Button class="primary-btn" :text="exportBtn" :icon="exportIcon" :hoverIcon="exportIconHover" @btnClick="exportClick" />
                <div class="time-wrap">
                    <TimePicker :pickData="pickData" @timeChange="setTimeRanger" :currentPicked="currentPicked"></TimePicker>
                    <el-date-picker
                        v-model="dateValue"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        :start-placeholder="startTimeLabel"
                        :end-placeholder="endTimeLabel"
                        :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                </div>
            </div>
            <el-table :data="slotProps.data && slotProps.data.list" style="width: 100%">
                <el-table-column v-for="(item, index) in props" :key="index" :prop="item.value" :label="item.label"> </el-table-column>
            </el-table>
            <el-pagination
                class="pagination"
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[10, 20, 30, 100]"
                :page-size="10"
                layout="total, prev, pager, next, jumper, sizes"
                :total="slotProps.data && slotProps.data.total"
            >
            </el-pagination>
        </div>
    </DataPanel>
</template>

<script>
import Button from "@/views/zhiji/bComponents/buttons/Button";
import DataPanel from "@/views/zhiji/components/pagesPanel/DataPanel";
import TimePicker from "@/views/zhiji/bComponents/switchs/TimePicker";
import { tableConfigs } from "../../config.js";
import { URLs } from "@/views/zhiji/js/common/constants.js";

export default {
    name: "Detail",
    props: ["lang", "channel"],
    components: {
        Button,
        DataPanel,
        TimePicker
    },
    data() {
        return {
            exportIcon: "url(" + this.zhiji.staticPath() + "class-spr.png) -388px -122px",
            exportIconHover: "url(" + this.zhiji.staticPath() + "class-spr.png) -388px -122px",
            currentPicked: 1,
            dateValue: [this.zhiji.getDate(new Date(), 7, "YYYY-MM-DD"), this.zhiji.getDate(new Date(), 1, "YYYY-MM-DD")],
            pickerOptions: {
                disabledDate(time) {
                    const day = 24 * 3600 * 1000;
                    return time.getTime() + 1 * day > Date.now();
                }
            },
            page: 1,
            size: 10
        };
    },
    computed: {
        props() {
            return tableConfigs();
        },
        exportBtn() {
            return this.$t("zhiji.common.export");
        },
        reqData() {
            return {
                lang: this.lang,
                startTime: this.dateValue[0],
                endTime: this.dateValue[1],
                page: this.page,
                size: this.size,
                channel: this.channel
            };
        },
        title() {
            return this.$t("zhiji.overview.robotTitle");
        },
        pickData() {
            return [
                {
                    label: this.$t("zhiji.dataPanel.yesterday"),
                    value: 1
                },
                {
                    label: this.$t("zhiji.dataPanel.sevenDays"),
                    value: 7
                },
                {
                    label: this.$t("zhiji.dataPanel.thirtyDays"),
                    value: 30
                }
            ];
        },
        startTimeLabel() {
            return this.$t("zhiji.serviceData.startTime");
        },
        endTimeLabel() {
            return this.$t("zhiji.serviceData.endTime");
        }
    },
    methods: {
        exportClick() {
            let reqUrl = URLs.SERVICE_DATA_DETAIL_DOWNLOAD + `?start_time=${this.reqData.startTime}&end_time=${this.reqData.endTime}`;
            let reqUrlParam = `&language=${this.reqData.lang}&channel=${this.reqData.channel}`;

            reqUrlParam = reqUrlParam.replace(/\s+/g, "");
            reqUrl = reqUrl + reqUrlParam;

            this.zhiji.requestByServiceName("getDownloadToken", reqUrl).then(result => {
                window.open(result, "_blank");
            });
        },
        setTimeRanger(dateStrs) {
            let start = Date.parse(dateStrs[0]) - getDayMilliseconds() * 1;
            let end = Date.parse(dateStrs[1]) - getDayMilliseconds() * 1;
            this.dateValue = [this.zhiji.dateFormat(new Date(start), "YYYY-MM-DD"), this.zhiji.dateFormat(new Date(end), "YYYY-MM-DD")];
        },
        handleSizeChange(data) {
            this.size = data;
        },
        handleCurrentChange(data) {
            this.page = data;
        }
    }
};
// 一天的秒数
function getDayMilliseconds() {
    return 24 * 60 * 60 * 1000;
}
</script>

<style lang="scss" scoped>
.opt-wrap {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .time-wrap {
        display: flex;
    }
    .primary-btn {
        color: #fff;
        background: #2ec2ff;
        box-shadow: 0 0 6px 2px rgba(46, 98, 151, 0.2);
        border-radius: 30px;
        justify-content: center;
        min-width: 96px;
    }
}
.pagination {
    padding: 8px 16px;
    background: #f2f7fb;
    border-width: 0 1px 1px 1px;
    border-style: solid;
    font-size: 12px;
    border-color: #e3ecf5;
    text-align: right;
    margin-bottom: 8px;
}
/deep/.el-pagination__editor.el-input .el-input__inner {
    border: 1px solid #d8e4f0;
}
</style>
